module.exports = __webpack_public_path__ + "img/job-Declined.fd16bfa5.svg";